<template>
  <v-dialog :value="value" persistent max-width="1100" style="overflow: hidden">
    <v-card dark>
      <v-row no-gutters>
        <v-col cols="12" md="7" style="max-height: 70vh" v-if="attachment.id">
          <template v-if="previewable">
            <v-img
              contain
              max-height="100%"
              v-if="isFileImage(attachment)"
              :src="getFilePublicUrl()"
            ></v-img>
            <iframe
              v-else
              :src="getFilePublicUrl()"
              frameborder="0"
              width="100%"
              height="500px"
              style="background-color: white"
            ></iframe>
          </template>
          <div
            style="background-color: white; width: 100%; height: 380px"
            class="d-flex align-center justify-center text-center"
            v-else
          >
            <div>
              <v-avatar color="grey lighten-2">
                <v-icon>mdi-file</v-icon> </v-avatar
              ><br />
              <div class="grey--text mt-2">
                {{ __("não há preview disponível para arquivos deste tipo") }}
              </div>
              <v-btn @click="downloadFile()" color="primary" text>{{
                __("download")
              }}</v-btn>
            </div>
          </div>
        </v-col>
        <v-col style="height: 100%">
          <v-form @submit.prevent="handleChangeFile">
            <v-card flat dark>
              <v-card-title>
                {{ __("arquivo") }}
                <v-spacer></v-spacer>
                <v-btn @click="downloadFile()" icon>
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-btn
                  @click="confirm_file_deletion = true"
                  icon
                  v-if="deletable"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn @click="handleClose()" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :label="__('nome')"
                  v-model="form.name"
                  prepend-icon="mdi-file"
                ></v-text-field>
                <v-textarea
                  :label="__('descrição')"
                  v-model="form.description"
                  auto-grow
                  prepend-icon="mdi-text"
                ></v-textarea>
              </v-card-text>
              <v-card-actions v-if="editable">
                <v-btn :loading="loading" type="submit" color="primary" block>{{
                  __("salvar")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-card>

    <confirm-action-dialog
      :confirm_action="confirm_file_deletion"
      @change="confirm_file_deletion = $event"
      @action="deleteFile()"
      :message="__('o arquivo será permanente excluído')"
    ></confirm-action-dialog>
  </v-dialog>
</template>

<script>
import {
  update as updateAttachment,
  destroy as deleteAttachment,
  previewable_extensions,
} from "@/services/attachment";

import ConfirmActionDialog from "@/components/ConfirmActionDialog";
import AttachmentsMixin from "@/mixins/AttachmentsMixin";
import i18n from "@/mixins/i18n";

export default {
  name: "file-dialog",
  props: {
    value: {
      type: Boolean,
    },
    attachment: {
      type: Object,
    },
    noDelete: {
      type: Boolean,
      default: false,
    },
    noEdit: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [AttachmentsMixin, i18n],
  components: { ConfirmActionDialog },
  data: () => ({
    i18n_prefix: "file",
    file: {},
    loading: false,
    form: {
      name: null,
      description: null,
    },
    confirm_file_deletion: false,
  }),
  methods: {
    async deleteFile() {
      try {
        if (this.$listeners.deleteAttachment == null) {
          await deleteAttachment(this.attachment.id);
        } else {
          await this.$listeners.deleteAttachment(this.attachment);
        }

        this.$emit("deleteFile", this.attachment.id);

        this.$store.commit("sendMessage", {
          text: this.__("arquivo excluído", "file"),
        });
        this.confirm_file_deletion = false;
        this.handleClose();
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: error.response.data.message,
          color: "red",
        });
      }
    },
    async handleChangeFile() {
      this.loading = true;

      const payload = {
        ...this.form,
      };

      try {
        let response;

        if (this.$listeners.updateAttachment == null) {
          response = await updateAttachment(payload, this.attachment.id);
        } else {
          response = await this.$listeners.updateAttachment(
            this.attachment,
            payload
          );
        }
        this.form = response;

        this.$emit("updateFile", this.form);

        this.$store.commit("sendMessage", {
          text: this.__("arquivo atualizado", "file"),
          color: "green",
        });
        this.$emit("refreshAttachments", this.attachment);
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: this.__("falha ao atualizar arquivo", "file"),
          color: "red",
        });
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.$emit("input", false);
      this.resetForm();
    },
    resetForm() {
      this.file = {};
      this.form = {
        name: null,
        description: null,
      };
    },
    getFilePublicUrl() {
      switch (this.attachment.extension) {
        case "xlsx":
        case "pptx":
        case "docx":
          return this.microsoft_preview(this.attachment.public_url);
        default:
          return this.attachment.public_url;
      }
    },
    microsoft_preview(public_url) {
      const url = encodeURIComponent(public_url);

      return `https://view.officeapps.live.com/op/embed.aspx?src=${url}`;
    },
    async downloadFile() {
      window.open(this.attachment.public_url);
    },
  },
  watch: {
    value: function (value) {
      if (value) {
        this.form = {
          name: this.attachment.name,
          description: this.attachment.description,
          category_id: this.attachment.category_id,
          extension: this.attachment.extension,
        };
      }
    },
  },
  computed: {
    deletable() {
      return this.noDelete === false;
    },
    editable() {
      return this.noEdit === false;
    },
    previewable() {
      return previewable_extensions.some(
        (extension) => extension == this.attachment.extension
      );
    },
  },
};
</script>
